(function () {
    'use strict';

    angular
        .module('homeMyTasksControllers')
        .controller('MyTasksRiskSelfAssessmentController', Controller);

    Controller.$inject = ['$scope', '$state', 'commonRiskSelfAssessmentService'];

    function Controller($scope, $state, commonRiskSelfAssessmentService) {

        var isAssessor = false;

        // Get IsAssessor
        commonRiskSelfAssessmentService
            .isAssessor()
            .then(function (isAssessorValue) {
                isAssessor = isAssessorValue;
                var withAssessor = isAssessorValue.IsAssessor && isAssessorValue.WithOpenedGovernanceProcess;

                $scope.tasksCountByName.riskAssessments = withAssessor ? !isAssessorValue.IsSubmitted && !isAssessorValue.IsComplete : 0;
                $scope.pendingsReviewCountByName.riskAssessments = withAssessor ? isAssessorValue.IsSubmitted && !isAssessorValue.IsComplete ? 1 : 0 : 0;
                $scope.pendingsReviewGovernanceProcessByName.riskAssessments = isAssessorValue;
            });

        // With Tasks
        $scope.withTasks = function () {
            return isAssessor.IsAssessor && isAssessor.IsInvited && !isAssessor.IsSubmitted && !isAssessor.IsComplete;
        };
        $scope.isAssessorUser = function () {
            return isAssessor.IsAssessor;
        };

        // Go To RiskSelfAssessment
        $scope.goToRiskSelfAssessment = function () {
            if (!$scope.isAssessorUser()) {
                return;
            }

            $state.go('riskSelfAssessmentAssess.assessor', { ItemPersonID: $scope.authenticatedUser.ItemPersonID });
        };
    }
})();